var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrentBid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.969,
    height: 35.035,
    viewBox: "0 0 38.969 35.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6206",
    "data-name": "Group 6206",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6193",
    "data-name": "Group 6193",
    transform: "translate(14.025 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3675",
    "data-name": "Path 3675",
    d: "M1331.431,556.607a2.437,2.437,0,0,1-2-1.037l-.754-1.076.865-1.6-.178-.254-1.331.931-4.655-6.649,1.33-.932-.178-.253-1.8.266-1.219-1.742a2.434,2.434,0,0,1,.6-3.391l6.65-4.657a2.44,2.44,0,0,1,3.391.6l1.219,1.74-.865,1.6.178.254,1.33-.931,4.656,6.649-1.33.932.179.253,1.8-.266.754,1.076a2.434,2.434,0,0,1-.6,3.392l-6.649,4.657A2.423,2.423,0,0,1,1331.431,556.607Zm-.847-2.223.179.254a.811.811,0,0,0,1.13.2l6.65-4.656a.812.812,0,0,0,.2-1.131l-.178-.254-1.8.267-1.684-2.405,1.33-.932-2.794-3.991-1.331.932-1.684-2.406.865-1.6-.644-.92a.813.813,0,0,0-1.131-.2l-6.649,4.656a.811.811,0,0,0-.2,1.13l.644.92,1.8-.266,1.684,2.405-1.33.931,2.794,3.991,1.329-.931,1.685,2.405Z",
    transform: "translate(-1321.076 -535.778)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6194",
    "data-name": "Group 6194",
    transform: "translate(18.323 7.422)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2457",
    "data-name": "Rectangle 2457",
    width: 4.059,
    height: 1.623,
    transform: "translate(0 2.327) rotate(-34.978)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6195",
    "data-name": "Group 6195",
    transform: "translate(22.978 5.094)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2458",
    "data-name": "Rectangle 2458",
    width: 2.435,
    height: 1.623,
    transform: "translate(0 1.396) rotate(-34.978)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6196",
    "data-name": "Group 6196",
    transform: "translate(22.048 12.742)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2459",
    "data-name": "Rectangle 2459",
    width: 4.059,
    height: 1.623,
    transform: "translate(0 2.327) rotate(-34.978)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6197",
    "data-name": "Group 6197",
    transform: "translate(26.703 10.414)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2460",
    "data-name": "Rectangle 2460",
    width: 2.435,
    height: 1.623,
    transform: "translate(0 1.396) rotate(-34.978)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6198",
    "data-name": "Group 6198",
    transform: "translate(0 11.351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3676",
    "data-name": "Path 3676",
    d: "M1307.048,566.952a2.681,2.681,0,0,1-.642-.078,3.365,3.365,0,0,1-1.905-1.421,2.984,2.984,0,0,1,.8-4.522c.484-.339,2.355-1.458,4.723-2.875,1.881-1.124,4.006-2.4,5.76-3.471a12.355,12.355,0,0,0,3.562-3.1,4.878,4.878,0,0,1,1.254-1.253l.655-.468.943,1.321-.661.472a3.3,3.3,0,0,0-.847.838,13.964,13.964,0,0,1-4.059,3.578c-1.758,1.077-3.889,2.352-5.775,3.481-2.154,1.288-4.188,2.506-4.625,2.811a1.4,1.4,0,0,0-.4,2.262,1.848,1.848,0,0,0,.964.775,1.643,1.643,0,0,0,1.3-.377c.436-.306,2.279-1.8,4.232-3.391,1.7-1.385,3.626-2.948,5.237-4.229a13.948,13.948,0,0,1,4.75-2.59,3.312,3.312,0,0,0,1.072-.506l.675-.463.918,1.338-.669.46a4.853,4.853,0,0,1-1.6.746,12.351,12.351,0,0,0-4.134,2.287c-1.606,1.277-3.524,2.836-5.223,4.218-2.146,1.744-3.84,3.121-4.325,3.461A3.449,3.449,0,0,1,1307.048,566.952Z",
    transform: "translate(-1303.799 -549.761)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6199",
    "data-name": "Group 6199",
    transform: "translate(29.228 26.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3677",
    "data-name": "Path 3677",
    d: "M1343.863,572h-1.624v-2.435H1339.8v-1.624h2.436a1.626,1.626,0,0,1,1.624,1.624Z",
    transform: "translate(-1339.804 -567.937)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6200",
    "data-name": "Group 6200",
    transform: "translate(17.863 26.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3678",
    "data-name": "Path 3678",
    d: "M1327.427,572H1325.8v-2.435a1.625,1.625,0,0,1,1.624-1.624h7.306v1.624h-7.306Z",
    transform: "translate(-1325.804 -567.937)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6201",
    "data-name": "Group 6201",
    transform: "translate(16.239 29.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3679",
    "data-name": "Path 3679",
    d: "M1342.475,577.619H1323.8v-4.059a1.625,1.625,0,0,1,1.624-1.624h8.93v1.624h-8.93V576h15.424v-2.435h-4.059v-1.624h4.059a1.626,1.626,0,0,1,1.623,1.624Z",
    transform: "translate(-1323.804 -571.937)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6202",
    "data-name": "Group 6202",
    transform: "translate(30.851 19.611)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2461",
    "data-name": "Rectangle 2461",
    width: 1.624,
    height: 3.247
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6203",
    "data-name": "Group 6203",
    transform: "translate(32.989 20.184)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2462",
    "data-name": "Rectangle 2462",
    width: 3.247,
    height: 1.624,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 0, 2.812)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6204",
    "data-name": "Group 6204",
    transform: "translate(34.772 22.561)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2463",
    "data-name": "Rectangle 2463",
    width: 3.247,
    height: 1.624,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 1.623)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6205",
    "data-name": "Group 6205",
    transform: "translate(35.722 26.105)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2464",
    "data-name": "Rectangle 2464",
    width: 3.247,
    height: 1.624
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentBid);
export default __webpack_public_path__ + "static/media/currentBid.61257ca466595959c1c14cd31565472a.svg";
export { ForwardRef as ReactComponent };